import { setTheme } from "theme/default/setTheme";

export const color_a0b9d2 = setTheme(({ theme }) => theme.colors.color_a0b9d2);
